<template>
  <div v-if="redeeming" class="loading_spinner_box">
    <div class="loading_spinner"></div>
  </div>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>{{ title }}</h2>
    </header>
    <div
      v-if="newGift"
      :class="[newGift ? 'w3-block' : '']"
      class="w3-modal z-index-0"
    >
      <div class="w3-modal-content w3-animate-top">
        <NewGift
          :products="GiftsData.GiftsProducts"
          @closeGiftForm="closeGiftForm"
          :contactno="ContactNo"
          :email="EMail"
          :fullname="Fullname"
          :phoneno="PhoneNo"
        />
        <div style="clear: both"></div>
      </div>
    </div>
    <div class="p-0 p-md-4">
      <div class="row">
        <div class="col-12 col-xl-10">
          <div class="row equalHeightColumns">
            <GiftSummaryCards
              :gifts="GiftsData"
              @equalHeightColumns="equalHeightColumns"
            />
            <div
              class="col-xl-4 col-md-6"
              style="max-width: 100%; min-height: 50px"
            >
              <NewInvestmentButton
                v-if="GiftsData.GiftsProducts"
                @click="newGift = true"
                :label="'PURCHASE GIFT'"
                @equalHeightColumns="equalHeightColumns"
              />
            </div>
          </div>

          <div class="w3-card mb-5 p-3 w3-white table-responsive">
            <div class="pt-3 pb-2 mb-0 w3-text-red bold">
              <h4>Gifts I Purchased</h4>
            </div>
            <img
              class="m-3 fetching"
              v-if="fetching"
              src="base/img/loading.gif"
              width="80"
            />
            <template v-else>
              <DataTable
                v-if="pRows?.length > 0"
                :tableid="'GiftsPurchased'"
                :headers="headers"
                :rows="pRows"
              />
              <div v-else class="p-5 w3-center w3-white">No gift found</div>
            </template>
          </div>
          <div class="w3-card mb-5 p-3 w3-white table-responsive">
            <div class="pt-3 pb-2 mb-0 w3-text-red bold">
              <h4>Gifts for me</h4>
            </div>
            <img
              class="m-3 fetching"
              v-if="fetching"
              src="base/img/loading.gif"
              width="80"
            />
            <template v-else>
              <DataTable
                v-if="pRows?.length > 0"
                :tableid="'GiftsList'"
                :headers="headers"
                :rows="lRows"
              />
              <div v-else class="p-5 w3-center w3-white">No gift found</div>
            </template>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>

    <!-- end: page -->
  </section>
</template>
<script>
import { useStore } from "vuex";
import { computed, onBeforeMount, onMounted, ref, watchEffect } from "vue";
import { formatCurrency, equalHeightColumns } from "@/helpers/utilities";
import DataTable from "@/components/DataTable.vue";
import NewGift from "@/components/NewGift.vue";
import GiftSummaryCards from "@/components/GiftSummaryCards";
import NewInvestmentButton from "@/components/NewInvestmentButton";
import axios from "axios";
import $ from "jquery";
export default {
  components: { DataTable, NewGift, GiftSummaryCards, NewInvestmentButton },
  setup() {
    const store = useStore();
    const title = ref("Gifts");
    const ContactNo = computed(() => store.state.userData.contactNo);
    const PhoneNo = computed(() => store.state.userData.PhoneNo);
    const EMail = computed(() => store.state.userData.EMail);
    const Fullname = computed(() => store.state.userData.Account_Name);

    const fetching = computed(() => store.state.fetching.GiftsData);
    const GiftsData = computed(() => store.state.GiftsData);
    const newGift = ref(false);

    if (!GiftsData.value) {
      store.dispatch("GiftsData");
    }
    const headers = [
      {
        key: "PurchaseDate",
        text: "Purchase Date",
        type: "date",
      },

      {
        key: "GiftAmount",
        text: "Gift Amount",
        type: "currency",
        class: "w3-right-align",
      },

      { key: "GiftPurpose", text: "Gift Purpose" },
      { key: "IsRedeemed", text: "Redeemed", type: "IsRedeemed" },
      { key: "BenefSurname", text: "Beneficiary Surname" },
      { key: "BenefFName", text: "Beneficiary First Name" },
      { key: "BenefEmail", text: "Beneficiary Email" },
      { key: "BenefPhoneNo", text: "Beneficiary PhoneNo" },
      {
        key: "GiftValue",
        text: "Gift Value",
        type: "currency",
        class: "w3-right-align",
      },
      {
        key: "RedeemeptionDate",
        text: "Redeemeption Date",
        type: "date",
      },
      { key: "PersonalMessage", text: "Personal Message" },
      { key: "PaidFor", text: "Paid For" },
      { key: "TransactionRef", text: "Transaction Ref" },

      { key: "ContactPhoneNo", text: "Contact Phone No" },
      { key: "ContactEmail", text: "Contact Email" },
      { key: "BenefProductId", text: "Product Id" },
      { key: "BenefProductName", text: "ProductName" },
      { key: "SerialNumber", text: "Serial Number" },
      { key: "Token", text: "Token" },
      { key: "ContactNo", text: "Contact No" },
    ];

    const pRows = ref([]);
    const lRows = ref([]);
    watchEffect(() => {
      if (
        GiftsData.value.GiftsPurchased &&
        GiftsData.value.GiftsPurchased.length
      ) {
        for (let i = 0; i < GiftsData.value.GiftsPurchased.length; i++) {
          pRows.value[i] = {};
          let gift = GiftsData.value.GiftsPurchased[i];
          for (const key in gift) {
            pRows.value[i][key] = {};
            pRows.value[i][key]["value"] = gift[key];

            for (const head in headers) {
              if (key === headers[head].key) {
                pRows.value[i][key]["class"] = headers[head].class ?? "";
                switch (headers[head].type) {
                  case "currency":
                    pRows.value[i][key]["value"] = formatCurrency(
                      gift[key],
                      "&#8358;"
                    );
                    break;
                  case "date":
                    pRows.value[i][key]["value"] = gift[key].split(" ")[0];
                    break;
                  case "IsRedeemed":
                    pRows.value[i][key]["value"] =
                      gift[key] === 1
                        ? '<i class="fa fa-check-circle"></i> YES'
                        : '<i class="fa fa-times-circle"></i> NO';
                    break;
                }
              }
            }
          }
        }
      }

      if (GiftsData.value.GiftsList && GiftsData.value.GiftsList.length) {
        for (let i = 0; i < GiftsData.value.GiftsList.length; i++) {
          lRows.value[i] = {};
          let GiftsList = GiftsData.value.GiftsList[i];
          for (const key in GiftsList) {
            lRows.value[i][key] = {};
            lRows.value[i][key]["value"] = GiftsList[key];

            for (const head in headers) {
              if (key === headers[head].key) {
                lRows.value[i][key]["class"] = headers[head].class ?? "";
                switch (headers[head].type) {
                  case "currency":
                    lRows.value[i][key]["value"] = formatCurrency(
                      GiftsList[key],
                      "&#8358;"
                    );
                    break;
                  case "date":
                    lRows.value[i][key]["value"] = GiftsList[key].split(" ")[0];
                    break;
                  case "IsRedeemed":
                    lRows.value[i][key]["class"] = "nowrap";
                    lRows.value[i][key]["value"] =
                      GiftsList[key] === 1
                        ? '<i class="fa fa-check-circle"></i> YES'
                        : '<i class="fa fa-times-circle"></i> NO <span data-Token="' +
                          GiftsList.Token +
                          '" data-ContactNo="' +
                          GiftsList.ContactNo +
                          '" data-SerialNumber="' +
                          GiftsList.SerialNumber +
                          '" class="redeemGift ml-4 w3-hover-text-black w3-text-red bold cursor">[Redeem Gift]</span>';
                    break;
                }
              }
            }
          }
        }
      }
    });
    const redeeming = ref(false);
    const redeemGift = (gift) => {
      redeeming.value = true;
      axios({
        method: "get",
        url: "/api/Gifts/RedeemGift",
        params: {
          Token: gift.Token,
          Serial: gift.SerialNumber,
          UserId: gift.ContactNo,
        },
      })
        .then((response) => {
          if (response.data.status === "success") {
            store.dispatch("GiftsData");
            if (response.data.result) {
              store.dispatch("showAlert", {
                message: "Gift redeemed successfully",
                status: "success",
                showing: true,
              });
            }
          } else {
            if (response.data.result) {
              store.dispatch("showAlert", {
                message: response.data.result,
                status: "error",
                showing: true,
              });
            }
          }
        })
        .catch((error) => {
          store.dispatch("showAlert", {
            title: "Error: " + error.code,
            message: error.message,
            status: "error",
            showing: true,
          });
        })
        .finally(() => {
          redeeming.value = false;
        });
    };

    const closeGiftForm = () => {
      newGift.value = false;
    };

    onMounted(() => {
      $(document).on("click", ".redeemGift", function (e) {
        e.stopPropagation();
        const Token = $(this).attr("data-Token");
        const ContactNo = $(this).attr("data-ContactNo");
        const SerialNumber = $(this).attr("data-SerialNumber");
        redeemGift({ Token, ContactNo, SerialNumber });
      });
    });
    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });
    return {
      title,
      GiftsData,
      EMail,
      ContactNo,
      Fullname,
      PhoneNo,
      fetching,
      formatCurrency,
      headers,
      pRows,
      lRows,
      redeeming,
      newGift,
      closeGiftForm,
      equalHeightColumns,
    };
  },
};
</script>
